import Vue from 'vue'
import Router from 'vue-router'

let Layout,Login

if(process.env.VUE_APP_FH_ARER === 'TRUE')
{
    Login = require('./views/login/loginTrue.vue').default
}
else
    Login = require('./views/login/login.vue').default

if(process.env.VUE_APP_FH_ARER === 'AIS')
    Layout = require('./components/layout.vue').default
else
    Layout = require('./components/layoutLeft.vue').default
    
clearInterval(window.timer)
window.timer = setInterval(function() {
  axios.post('/JSONAPI',{
    cmdType:'GET_SYSTEM_MODE'
  })
  .then((response) =>{
          
  })
  .catch( (error) =>{
    clearInterval(window.timer)
  })
}, 5000)

Vue.use(Router)

let defRoutes  = [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/login.html',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/home',
      name: 'home',
      component: Layout,
      meta: { requiresAuth: true }
    },
    {
      path: '/status',
      name: 'status',
      component: Layout,
      meta: { requiresAuth: true }
    },
    {
      path: '/basicSetup',
      name: 'basicSetup',
      component: Layout,
      meta: { requiresAuth: true }
    },
    {
      path: '/advanceSetup',
      name: 'advanceSetup',
      component: Layout,
      meta: { requiresAuth: true }
    },
    {
      path: '/application',
      name: 'application',  
      component: Layout,
      meta: { requiresAuth: true }
    },
    {
      path: '/management',
      name: 'management',
      component: Layout,
      meta: { requiresAuth: true }
    }
]


const router  = new Router({
    routes: defRoutes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        let loggedIn = cookie.getItem('uuid') ? true : false
        
        if (!loggedIn) {
        next({
            path: '/',
        })
        } else {
        next()
        }
    } else {
        next() // 确保一定要调用 next()
    }
})

export default router